const initialState = () => ({
  selectedKeyword: null,
  keywordOccurrences: null,
  keywordIndex: 1,
  keywordLocations: [],
  keywordSwitching: false,
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  setSelectedKeyword({ commit }, { keyword, occurrences }) {
    commit('SET_SELECTED_KEYWORD', { keyword, occurrences });
  },
  findKeywordLocations({ commit }, { keyword, matchedKwByDocument, documents }) {
    return commit('FIND_KEYWORD_LOCATIONS', { keyword, matchedKwByDocument, documents });
  },
  findManualKeywordLocations({ commit }, { searchResult }) {
    return commit('FIND_MANUAL_KEYWORD_LOCATIONS', { searchResult });
  },
  incrementKeywordIndex({ commit }) {
    commit('INCREMENT_KEYWORD_INDEX');
  },
  decrementKeywordIndex({ commit }) {
    commit('DECREMENT_KEYWORD_INDEX');
  },
  setKeywordSwitching({ commit }, boolean) {
    commit('KEYWORD_SWITCHING', boolean);
  },
  resetSelectedKeyword({ commit }) {
    commit('RESET_SELECTED_KEYWORD');
  },
  RESET({ commit }) {
    commit('RESET_STORE');
  },
};

const mutations = {
  FIND_KEYWORD_LOCATIONS(state, { keyword, matchedKwByDocument, documents }) {
    const resultArray = [];
    for (const match in matchedKwByDocument) {
      if (matchedKwByDocument[match].keyword.id === keyword.id) {
        const docMatch = matchedKwByDocument[match];
        const doc = documents.find((doc) => doc.id === docMatch.docId);
        if (docMatch.pages.length > 0) {
          resultArray.push({
            docName: doc.name,
            docId: doc.id,
            pages: docMatch.pages,
          });
        }
      }
    }
    state.keywordLocations = resultArray.sort((a, b) => a.docName.localeCompare(b.docName));
  },
  FIND_MANUAL_KEYWORD_LOCATIONS(state, { searchResult }) {
    // Reset previous manual keyword locations
    state.keywordLocations = [];

    const keywordLocations = [];
    searchResult.forEach((match) => {
      const pages = match.spans.map((span) => span.start.page);
      const count = match.spans.length;
      // FIXME: docName
      keywordLocations.push({ docId: match.documentId, docName: '', pages, count });
    });
    state.keywordLocations = keywordLocations;
  },
  SET_SELECTED_KEYWORD(state, { keyword, occurrences }) {
    if (state.selectedKeyword && state.selectedKeyword.id == null) {
      let keywordNodes = document.querySelectorAll(`[class*=keyword-null]`);
      keywordNodes.forEach((node) => node.remove());
    }
    state.selectedKeyword = keyword;
    state.keywordOccurrences = occurrences;
    state.keywordIndex = 1;
  },
  INCREMENT_KEYWORD_INDEX(state) {
    state.keywordIndex++;
  },
  DECREMENT_KEYWORD_INDEX(state) {
    state.keywordIndex--;
  },
  KEYWORD_SWITCHING(state, boolean) {
    state.keywordSwitching = boolean;
  },
  RESET_SELECTED_KEYWORD(state) {
    if (state.selectedKeyword && state.selectedKeyword.id == null) {
      let keywordNodes = document.querySelectorAll(`[class*=keyword-null]`);
      keywordNodes.forEach((searchKeywordNode) => {
        const parent = searchKeywordNode.parentNode;
        // move all the search node’s children (including any nested <keyword>…)
        // up into the parent, right before the search node
        // effectively unwrapping the search node
        while (searchKeywordNode.firstChild) {
          parent.insertBefore(searchKeywordNode.firstChild, searchKeywordNode);
        }
        // now that the search node is empty, remove it
        parent.removeChild(searchKeywordNode);
      });
    }
    state.selectedKeyword = null;
    state.keywordOccurrences = null;
    state.keywordIndex = 1;
  },
  RESET_STORE(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  selectedKeyword: (state) => state.selectedKeyword,
  keywordOccurrences: (state) => state.keywordOccurrences,
  keywordIndex: (state) => state.keywordIndex,
  keywordSwitching: (state) => state.keywordSwitching,
  keywordLocations: (state) => state.keywordLocations,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunityKeywordSearch = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export function findSequenceCount(dictionaries, maxDifference) {
  let pages = [];
  let count = 0;

  // Iterate over each dictionary in the array
  dictionaries.forEach((dictionary) => {
    // Iterate over each page in the dictionary
    for (let page in dictionary.indexes) {
      // Ensure the page exists in all dictionaries
      if (dictionaries.every((dict) => dict.indexes.hasOwnProperty(page))) {
        // Get the word indices arrays from both dictionaries for the current page
        const wordIndices1 = dictionary.indexes[page];
        const wordIndices2 = dictionaries[1].indexes[page]; // Assuming there are only 2 dictionaries

        // Iterate over word indices from the first dictionary
        for (let i = 0; i < wordIndices1.length; i++) {
          // Iterate over word indices from the second dictionary
          for (let j = 0; j < wordIndices2.length; j++) {
            // Check if the condition is satisfied
            if (
              wordIndices1[i] < wordIndices2[j] &&
              wordIndices2[j] - wordIndices1[i] < maxDifference + dictionary.keyword.length - 1
            ) {
              pages.push(page);
              count++;
            }
          }
        }
      }
    }
  });

  return { pages, count };
}
